import { render, staticRenderFns } from "./LcView.vue?vue&type=template&id=28dc30a8&scoped=true"
import script from "./LcView.vue?vue&type=script&lang=js"
export * from "./LcView.vue?vue&type=script&lang=js"
import style0 from "./LcView.vue?vue&type=style&index=0&id=28dc30a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28dc30a8",
  null
  
)

export default component.exports